import { AUTH_CH, AUTH_CH_DATA, AUTH_SET, AUTH_LOUT } from '../constants';
import { updateObject, createReducer } from './common';

export const initialState = { 
    uType: '',
};

const handler = {
    [AUTH_CH]: (state) => updateObject(state, { uType: '' }),
    [AUTH_CH_DATA]: (state, action) => updateObject(state, { uType: action.payload }),
    [AUTH_SET]: (state) => updateObject(state, { uType: '' }),
    [AUTH_LOUT]: (state) => ({ ...initialState }),    
}

export const authReducer = createReducer(initialState, handler);